import { getPack, getPackPlans } from '~/utility/fetchAPI'

export function usePack(packScreenName: string, queryConfig = {}) {
  const api = useNuxtApp().$api
  const pack = ref<Object | null>(null)
  const packPlans = ref<Object[] | null>(null)

  onMounted(async () => {
    try {
      pack.value = (await getPack(api, packScreenName, queryConfig))?.data
      packPlans.value = (await getPackPlans(api, packScreenName, queryConfig))?.data
    } catch (error) {
      return false
    }
  })

  return {
    pack,
    packPlans,
  }
}
